import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    input: {
      width: '100%',
      maxWidth: 360,
      marginBottom: MIDDLE_MARGIN,
    },
    logoBlock: {
      width: '100%',
    },
    logoTitle: {
      fontColor: colorsPalette.white,
      fontWeight: 'bold',
      marginBottom: MIDDLE_MARGIN,
      fontSize: 18,
      lineHeight: '22px',
    },
    logoWrapper: {
      marginBottom: MIDDLE_MARGIN,
    },
    logo: {
      width: 140,
    },
    logoErr: {
      color: colorsPalette.error,
      fontSize: 12,
      margin: '3px 14px 0 14px',
    },
    dropzone: {
      width: '100%',
      border: `1px dashed ${fade(colorsPalette.white, 0.33)}`,
      borderRadius: 8,
      padding: MIDDLE_MARGIN,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginBottom: MIDDLE_MARGIN,
      '&:focus': {
        outline: 'none',
      },
    },
    dropzoneText: {
      color: colorsPalette.gray,
      fontSize: 16,
      lineHeight: '26px',
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        lineHeight: '26px',
      },
    },
    dropzoneButton: {
      marginTop: SMALL_MARGIN,
    },
    logoRow: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      minHeight: 40,
    },
    logoName: {
      marginLeft: MIDDLE_MARGIN,
      color: colorsPalette.gray,
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '22px',
    },
    logoInfo: {
      display: 'flex',
      alignItems: 'center',
      marginRight: MIDDLE_MARGIN,
    },
    removeButton: {
      padding: 5,
    },
    closeIcon: {
      width: 14,
      height: 14,
    },
  }),
);

export default useStyles;
